module.exports = __webpack_public_path__ + "img/bgtop.47840566.jpg";